import { useState, useEffect } from 'react';
import Layout from 'components/Layout';
import NextImage from 'components/NextImage';
import SEO from 'components/Seo';
import Link from 'next/link';
import classes from './styles.module.scss';
import { Button, Heading, useDisclosure, Text } from '@chakra-ui/react';
import { featureSchema } from 'data/Schema/featureSchema';
import { useRouter } from 'next/router';
import { FaChevronLeft } from 'react-icons/fa';
import useMediaQuery from 'hooks/useMediaQuery';
import clsx from 'clsx';
import SKButton from 'components/UI/SKButton';

const FeaturePage = () => {
  const router = useRouter();

  const [showLength, setShowLength] = useState(3);

  const featureData = [
    {
      image: '/assets/images/features/Sikka_Features_2.png',
      title: 'All Offers and My Offers',
      description:
        'The online money earning app contains ‘All Offers’ and ‘My Offers’ sections. All the available offers are shown under the ‘All Offers’ and the user-selected offers are shown under the ‘My Offers’ section.'
    },
    {
      image: '/assets/images/features/Sikka_Features_3.png',
      title: 'Complete simple offers',
      description:
        'You can complete your favorite offers in Sikka to earn instant online money in your Sikka wallet.'
    },
    {
      image: '/assets/images/features/Sikka_Features_4.png',
      title: 'Daily offers',
      description:
        'Try out new and exciting offers every day to earn maximum Sikka coins in the Sikka online money earning app and supercharge your wallet with cash rewards.'
    },
    {
      image: '/assets/images/feature_page/daily-checkin-to-sikka-pro.png',
      title: 'Daily check in into Sikka',
      description:
        'Maintain a streak by visiting the Sikka app daily to earn daily cash rewards. Breaking the streak might affect the daily online money earnings.'
    },
    {
      image: '/assets/images/feature_page/refer-earn-features.png',
      title: 'Refer and earn',
      description:
        'You can refer the app to your friends by sending them a referral, and asking them to complete some offers. If your friend completes a minimum of three offers, you earn a reward worth 50% of their online money earnings.'
    },
    {
      image: '/assets/images/feature_page/referral-benefits.png',
      title: 'Referral benefits',
      description:
        'Use the referral code sent by your friend to earn Sikkas and boost your reward in the Sikka wallet.'
    },
    {
      image: '/assets/images/feature_page/hassle-free-money-transfer.png',
      title: 'Hassle-free money transfer',
      description:
        'The process is highly transparent. Redeem your daily cash or daily online money earnings from Sikka online money earning app. How do you do it? Transfer your Sikka coins from the wallet directly to your bank account through UPI. '
    },
    {
      image: '/assets/images/feature_page/exclusive-games-features.png',
      title: 'Exclusive games',
      description:
        'Enjoy fun, free mini-games in your downtime on Sikka — pure entertainment, with no cash or coin investment involved.'
    }
  ];

  const schemaCodes = [
    {
      type: 'application/ld+json',
      code: JSON.stringify(featureSchema)
    }
  ];

  const isTab = useMediaQuery('(max-width: 1000px)');

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        url={router.pathname}
        title="Online Money Earning App | Online Money Earnings - Sikka"
        description="The brand new Sikka online money earning app offers user-friendly features to earn from anywhere. Start your online money earnings with the Sikka now."
        keywords={['Online Money Earning App', 'Online Money Earnings']}
        schemaCodes={schemaCodes}
        image={'/assets/images/features/Sikka_Features_Hero.png'}
      />
      <section className={classes.banner}>
        <div className={classes.header}>
          {isTab && (
            <Link href={'/'}>
              <FaChevronLeft />
            </Link>
          )}
          <h1>Features of Online Money Earning App</h1>
        </div>
        <NextImage
          className={{ imageContainer: classes.bannerImage }}
          src={'/assets/images/features/Sikka_Features_Hero.png'}
          alt="Features of Online Money Earning App"
          title="Features of Online Money Earning App"
          fill
        />
        <p>
          The brand new Sikka online money earning app offers straightforward
          and user-friendly features to earn from anywhere. Here are some
          exciting features of the app.
        </p>
      </section>
      <section className={classes.listSection}>
        {featureData
          .filter((item, index) => index < showLength)
          .map((val, index) => (
            <div className={classes.gridCard} key={val.title}>
              <NextImage
                className={{
                  imageContainer: clsx(
                    classes.image,
                    (index === 1 ||
                      index === 2 ||
                      index === 4 ||
                      index === 5) &&
                    classes.bigImage
                  )
                }}
                src={val.image}
                alt={val.title}
                title={val.title}
                fill
              />
              <div className={classes.content}>
                <h2>{val.title}</h2>
                <p>{val.description}</p>
              </div>
            </div>
          ))}
      </section>
      {showLength === 3 && (
        <section className={classes.btnSection}>
          <SKButton
            className={classes.viewBtn}
            onClick={() => setShowLength(featureData.length)}
          >
            View More
          </SKButton>
        </section>
      )}
    </Layout>
  );
};

export default FeaturePage;
